<template lang="pug">
#upload-verificacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.tituloUpload")',
        icon='mdi mdi-file-multiple',
        :btnTexto='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.botaoAnalises")',
        :exibeBotao='true',
        :voltarPara='true',
        @btnHeaderClicado='analisesAnteriores'
    )

    .view-container.margen-bottom-pages
        main
            section
                h3.cadastro-contrato-originacao__subtitulo {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.subtituloUploadPlanilhaAnalise') }}
                InserirViaPlanilha(
                    @emitTerritoriosVerificados='atualizarTerritorios',
                    @emitErrosUpload='atualizarErros'
                )

            section
                .upload-verificacao
                    h3.cadastro-contrato-originacao__subtitulo {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.subTituloListagemTerritoriosProdutores') }}

                el-card(
                    :body-style='{ padding: "0px", height: "100%" }',
                    shadow='never',
                    style='display: flex; flex-direction: column; flex: 1'
                )
                    Tabela(:key="listagemTableKey('upload-verif', territoriosVerificados, paginacao.pagina + 1)", :territoriosVerificados='territoriosVerificados')

                    .cadastro-contrato-originacao__paginador
                        b {{ qtdItens }}
                        el-pagination(
                            small,
                            background,
                            layout='prev, pager, next',
                            :page-size='paginacao.tamanho',
                            :current-page.sync='paginacao.pagina',
                            :total='paginacao.total',
                            @current-change='atualizarPagina'
                        )

            ModalErroPlanilha(
                :dados='errosUpload',
                :show='modalVerificacao',
                @voltar='modalVerificacao = false'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import InserirViaPlanilha from '@/components/contratosOriginacao/EmpresaBlocoUploadVerificacao.vue';
import Tabela from '@/components/contratosOriginacao/TabelaVerificacaoTerritoriosProdutores.vue';
import ModalErroPlanilha from '@/components/contratosOriginacao/ModalErroProcessamentoVerificacao.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'EmpresaUploadVerificacao',
    components: {
        BaseHeader,
        InserirViaPlanilha,
        Tabela,
        ModalErroPlanilha
    },

    data() {
        return {
            territoriosVerificados: [],
            errosUpload: [],
            modalVerificacao: false,
            paginacao: {
                pagina: 0,
                tamanho: 10,
                total: 0
            }
        };
    },

    computed: {
        qtdItens() {
            const total = this.paginacao?.total ?? 0;
            const key =
                total === 1
                    ? 'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                    : 'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratos';

            return `${total} ${this.$t(key)}`;
        },
        ...mapGetters(['isAlvorada', 'usuarioLogado'])
    },

    methods: {
        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina;
        },

        atualizarTerritorios(territorios) {
            this.territoriosVerificados = territorios;
        },

        atualizarErros(erros) {
            this.errosUpload = [...erros];
            this.modalVerificacao = true;
        },

        ordenarTabela(ordenacao) {
            this.paginacao.ordenacao = ordenacao;
        },

        analisesAnteriores() {
            this.$router.push({ name: 'HistoricoRecebimentosEmpresa' });
        }
    }
};
</script>

<style lang="scss">
#upload-verificacao {
    main {
        margin: 16px 0;

        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .el-card {
        border-radius: 10px;
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .cadastro-contrato-originacao__paginador {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 4px 16px;

        b {
            color: var(--primary);
            font-size: 12px;
        }
    }

    .upload-verificacao {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        align-items: center;
    }
    .cadastro-contrato-originacao__subtitulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }
}
</style>
